import { render, staticRenderFns } from "./NavigationTopbar.vue?vue&type=template&id=b4f7b922&scoped=true"
import script from "./NavigationTopbar.vue?vue&type=script&lang=ts"
export * from "./NavigationTopbar.vue?vue&type=script&lang=ts"
import style0 from "./NavigationTopbar.vue?vue&type=style&index=0&id=b4f7b922&prod&lang=css"
import style1 from "./NavigationTopbar.vue?vue&type=style&index=1&id=b4f7b922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f7b922",
  null
  
)

export default component.exports